$(async function() {
    let contactPage = $('.contact');
    
    if (!contactPage) {
        return;
    }

    let typeSelect = $('#type');
    let regionSelect = $('#region');
    let regionLabel = $('#region-label');
    let paysSelect = $('#pays');
    let paysLabel = $('#pays-label');
    let regionContainer = $('#region-container');
    let paysContainer = $('#pays-container');
    let contactInput = $('#contacts');
    let userContainer = $('#user-container');
    let departementContainer = $('#departement-container');
    let countryLabel = $('.country-label');
    let franceLabel = countryLabel.data('country-name')

    // on récupère le tableau des contacts
    let locale = $("#locale").data("locale");
    let contacts = await getContacts(locale);

    // Fonction pour remplir les options d'un select avec des valeurs uniques
    function populateSelect(selectElement, items, placeholder, level) {
        selectElement.empty(); // Réinitialiser les options
        selectElement.append($('<option></option>').attr('value', '').text(placeholder)); // Ajout de l'option par défaut

        let normalContacts = items.filter(contact => !contact.isLast);
        let uniqueItems = [...new Map(normalContacts.map(contact => [contact[level], contact])).values()]
            .sort((a, b) => (a[level] || '').localeCompare(b[level] || ''));

        uniqueItems.forEach(item => {
            selectElement.append($('<option></option>').attr('value', item[level]).text(item[level]));
        });
        // Filtrer le contact `isLast` en fonction du niveau
        let lastContact = items.find(
            contact => contact.isLast && (
                level === 'region' ? !contact.pays : contact.pays
            )
        );
        
        if (lastContact) {
            selectElement.append($('<option></option>').attr('value', lastContact[level]).text(lastContact[level]));
        }
    }

    // Gestion du changement de type de projet Projet/Autre
    typeSelect.on('change', function () {
        let selectedType = $(this).val();

        if (selectedType === 'projet') {
            regionContainer.removeClass('d-none');

            paysContainer.addClass('d-none');
            paysSelect.empty();
            userContainer.addClass('d-none');
            departementContainer.addClass('d-none');
            $('#department').val(''); 

            // Filtrer les contacts par type
            let filteredContacts = contacts.filter(contact => contact.type === ('Projet'));

            // Permet d'avoir la bonne traduction pour le placeholder
            let placeholderRegion = regionLabel.text();
            
            // Remplir le sélecteur avec les régions uniques
            populateSelect(regionSelect, filteredContacts, placeholderRegion, 'region');

            if (selectedType === 'autre') {
                paysContainer.addClass('d-none');
                paysSelect.empty();
            }
        } else if (selectedType === 'autre') {
            regionContainer.addClass('d-none');
            regionSelect.empty();
            paysContainer.addClass('d-none');
            paysSelect.empty();
            departementContainer.addClass('d-none');
            $('#department').val(''); 

            let filteredContacts = contacts.filter(contact => contact.type === ('Autre'));
            
            contactInput.val(filteredContacts.map(contact => contact.id).join(', '));
            userContainer.removeClass('d-none');
        } else {
            // Cacher les sélecteurs si aucun type valide n'est sélectionné
            regionContainer.addClass('d-none');
            regionSelect.empty();
            paysContainer.addClass('d-none');
            paysSelect.empty();
            userContainer.addClass('d-none');
            departementContainer.addClass('d-none');
            $('#department').val(''); 
        }
    });

    // Gestion du choix de pays
    regionSelect.on('change', function () {
        let selectedRegion = $(this).val();

        // Filtrer les contacts correspondant à la région sélectionnée
        let filteredContacts = contacts.filter(contact => contact.region === selectedRegion);
        
        // Vérifier si aucun contact n'a de 'pays' définis
        let hasNoPays= filteredContacts.every(contact => !contact.pays);
        
        let hasPays = filteredContacts.every(contact => contact.pays);
        
        if (hasNoPays) {
            // Remplir l'input avec les emails des contacts filtrés
            contactInput.val(filteredContacts.map(contact => contact.id).join(', '));
            // on affiche pas le selecteur de pays (il est vide)
            paysContainer.addClass('d-none');
            paysSelect.empty();
            userContainer.removeClass('d-none');
            departementContainer.addClass('d-none');
            $('#department').val(''); 
        }

        // si on as que des contacts avec pays, on affiche le selecteur
        if (hasPays) {
            paysContainer.removeClass('d-none');
            userContainer.addClass('d-none');
            let placeholderPays = paysLabel.text();
            populateSelect(paysSelect, filteredContacts, placeholderPays, 'pays');
        }
    });

    paysSelect.on('change', function () {
        let selectedPays = $(this).val();
        let filteredContacts = contacts.filter(contact => contact.pays === selectedPays);

        contactInput.val(filteredContacts.map(contact => contact.id).join(', '));

        // Si le pays selectionné est la france, on affiche l'input text de departement
        if (selectedPays === franceLabel) {
            departementContainer.removeClass('d-none');
        }
        if (selectedPays !== franceLabel) {
            departementContainer.addClass('d-none');
            $('#department').val(''); 
        }
        userContainer.removeClass('d-none');

    });
});

async function getContacts(locale) {
    let response = await fetch(`/controller/prodeval/contacts?locale=${encodeURIComponent(locale)}`);
    let data = await response.json();
    return data;
}